module.exports = __webpack_public_path__ + "static/media/service5.926b317f.jpg";